// extracted by mini-css-extract-plugin
export default {"metaCardConteiner":"meta-tag-card_metaCardConteiner__gNXaE","field":"meta-tag-card_field__Ovksr"};